import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react'
import { cn } from '@/utils/cn'

interface MetricCardProps {
  icon: React.ElementType
  label: string
  value: string | number
  subValue?: string
  trend?: {
    direction: 'up' | 'down' | 'neutral'
    delta: number | null
  }
  iconBg?: string
  iconColor?: string
  onClick?: () => void
}

export function MetricCard({
  icon: Icon,
  label,
  value,
  subValue,
  trend,
  iconBg: _iconBg,
  iconColor: _iconColor,
  onClick,
}: MetricCardProps) {
  const Wrapper = onClick ? 'button' : 'div'
  return (
    <Wrapper
      onClick={onClick}
      className={cn(
        "bg-framed-neutral-100 rounded-2xl p-5 text-left w-full hover:bg-framed-neutral-200 transition-colors duration-150",
        onClick && "cursor-pointer"
      )}
    >
      <p className="text-[11px] font-medium tracking-wide uppercase text-framed-neutral-500 mb-2 flex items-center gap-1.5">
        <Icon className="w-4 h-4 text-framed-neutral-500" />
        {label}
      </p>
      <div className="flex items-end justify-between">
        <div>
          <p className="font-display text-3xl font-bold text-framed-neutral-800">{value}</p>
          {subValue && (
            <p className="text-xs text-framed-neutral-500 mt-1">{subValue}</p>
          )}
        </div>
        {trend && trend.delta !== null && (
          <div className={cn(
            'flex items-center gap-1 text-xs font-medium',
            trend.direction === 'up' && 'text-emerald-600',
            trend.direction === 'down' && 'text-red-600',
            trend.direction === 'neutral' && 'text-framed-neutral-500'
          )}>
            {trend.direction === 'up' && <ArrowUpRight className="w-3 h-3" />}
            {trend.direction === 'down' && <ArrowDownRight className="w-3 h-3" />}
            {trend.direction === 'neutral' && <Minus className="w-3 h-3" />}
            <span>{Math.abs(trend.delta).toFixed(1)}%</span>
          </div>
        )}
      </div>
    </Wrapper>
  )
}
